import React from "react";
import { toast } from "react-toastify";
import { ToastNotification } from "carbon-components-react/lib/components/Notification";

const CarbonToast = ({ closeToast, ...props }) => (
  <ToastNotification {...props} onCloseButtonClick={closeToast} />
);

export function toastTheError(error) {
  if (typeof error == "string") {
    toast.error(error, {
      position: getToastPosition(),
      toastId: slugify(error)
    });
  } else {
    const toastData = getToastData(error);
    /*toast.error(toastData.message, {
      position: getToastPosition(),
      toastId: toastData.id
    });*/
    if (toastData && toastData.message) {
      toast(
        <CarbonToast
          kind="error"
          title={toastData.message}
          subtitle={""}
          caption={""}
        />
      );
    }
  }
}

export function toastMessage(message, type = "info") {
  toast(
    <CarbonToast
      kind="info"
      title={message}
      subtitle={""}
      caption={""}
    />
  );
}

function getToastPosition() {
  return isMobile() ? toast.POSITION.BOTTOM_CENTER : toast.POSITION.TOP_CENTER;
}

function getToastData(error) {
  try {
    if (error.data) {
      if (error.data.code) {
        if (typeof error.data.code == "string") {
          return { message: error.data.code, id: slugify(error.data.code) };
        } else {
          return {
            message: error.data.code[0],
            id: slugify(error.data.code[0])
          };
        }
      } else if (typeof error.data.error_message == "string") {
        return {
          message: error.data.error_message,
          id: slugify(error.data.error_message)
        };
      } else {
        return {
          message: error.data.error_message[0],
          id: slugify(error.data.error_message[0])
        };
      }
    } else if (error.message) {
      return {
        message: error.message,
        id: slugify(error.message)
      };
    }
  } catch (error) {
    return { message: "Unexpected error!", id: slugify("Unexpected error!") };
  }
}

/**
 * girilen textten slug yaratir
 */
function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

export function isMobile() {
  return "ontouchstart" in document.documentElement;
}
